import { Injectable } from '@angular/core'; //permite definir los servicios e inyectarlos en cauqluier otra clase
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'; //para enviar cabezeras en las peticiones ajax
import { Observable } from 'rxjs/Observable'; //recoger las respuestas que nos devuelve el API
import { GLOBAL } from './global'; // la url del API
import { Reconocimiento } from '../models/reconocimiento';

@Injectable()
export class ReconocimientoService{

    public url:string; //url de nuestro backend

    constructor(public _http:HttpClient){
        this.url = GLOBAL.url;
    }

    /* CATALOGO */

    GRIDlistar(token:string): Observable<any>{
        let headers = new HttpHeaders().set('Content-Type','application/json')
                                       .set('Authorization',token);

        return this._http.get(this.url+'GRID-listar-reconocimientos', {headers:headers});
    }

    /* FUNCIONES */

    /**************************************/

    gestion(item: Reconocimiento,token:string): Observable<any>{
        let params = JSON.stringify(item);
        let headers = new HttpHeaders().set('Content-Type','application/json')
                                       .set('Authorization',token);

        if(item.ID==0){
            return this._http.post(this.url+'reconocimiento-agregar',params, {headers:headers});
        }
        else{
            return this._http.put(this.url+'reconocimiento-modificar',params,{headers:headers});
        }
    }

    obtenerActivas(token:string):Observable<any>{
        let headers = new HttpHeaders().set('Content-Type','application/json')
                                       .set('Authorization',token);

        //let params = JSON.stringify({ID_SUCURSAL:ID_SUCURSAL});

        return this._http.get(this.url+'reconocimientos-obtener-activas',{headers:headers});
    }
}